import { render, staticRenderFns } from "./UserRecommend.vue?vue&type=template&id=4600c087&"
import script from "./UserRecommend.vue?vue&type=script&lang=js&"
export * from "./UserRecommend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports